module.exports = __webpack_public_path__ + "static/img/left.b1d01f5b.svg";